import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Droit } from 'src/app/classes/droit';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';
import { Utilisateur } from 'src/app/classes/utilisateur';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from './custom-validators';
@Component({
  selector: 'app-dialogue-user',
  templateUrl: './dialogue-user.component.html',
  styleUrls: ['./dialogue-user.component.css']
})
export class DialogueUserComponent implements OnInit, OnChanges {
  @Input("is-visible") isVisible: boolean;
  @Input("data") data: Utilisateur = {
    id: 0,
    nom: '',
    prenom: '',
    droit: '',
    matricule: 0,
    mot_de_passe: '',
    email: '',
    droit_object: new Droit(0, '')
  };
  @Output() changeVisibleEvent = new EventEmitter<boolean>();
  public frmSignup: FormGroup;
  droits: any[] = [];
  isClient: boolean;
  selectedDroit: string = "";
  id_utilisateur: number;
  nom: string;
  prenom: string;
  matricule: string;
  mot_de_passe: string;
  isNewUser: boolean;
  labelButtonValidation: string;

  constructor(private droitService: UtilisateursService, private fb: FormBuilder) {
    this.frmSignup = this.createSignupForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changed");
    if(this.data !== null && this.data !== undefined) {
      this.id_utilisateur = this.data.id;
      this.nom = this.data.nom;
      this.prenom = this.data.prenom;
      this.selectedDroit = this.data.droit;
      console.log(this.data.droit);

      if(this.droits.length > 0) {
        this.droits.forEach( current => {
          if(current.label === this.data.droit) {
            this.selectedDroit = current.value;
          }
        });
      }
    }
  }


  ngOnInit(): void {
    this.labelButtonValidation = 'Valider';

    if(this.data === undefined) {
      this.data = {
        id: 0,
        nom: '',
        prenom: '',
        droit: '',
        matricule: 0,
        mot_de_passe: '',
        email: '',
        droit_object: null
      }
    }

    console.log("created");
    if(this.data !== null && this.data !== undefined) {
      this.id_utilisateur = this.data.id;
      this.nom = this.data.nom;
      this.prenom = this.data.prenom;
      this.selectedDroit = this.data.droit;
      console.log("Data Go");
    } 
    this.loadAllDroit();
  }
  loadAllDroit(): void {
    this.droits = [];
    this.droitService.getAllListDroit().subscribe(data => {
      const listeDroit = data['listedroit'];
      for (let i = 0; i < listeDroit.length; i++ ) {
        const objet_DroitAsset = listeDroit[i];
        if (objet_DroitAsset) {
          const objet = {
            label: objet_DroitAsset.designation_droit,
            value: objet_DroitAsset.id_droit
          };
          this.droits.push(objet);
        }
      }
    });
  }
  // Action insertion utilisateur
  insertOrUpdateUser(): void {
    if(this.selectedDroit.trim() === '' || this.data.nom.trim() === '' || this.data.prenom.trim() === '')
    {
      alert('Veuillez remplir tous les champs!');
      return;
    }
    // Check Obligatoire Email
    if(this.isClient && this.data.email.trim() === '')
    {
      alert('Veuillez remplir le champs email!');
      return;
    }
    const object: any = {};
    object.id = this.data.id;
    object.nom = this.data.nom;
    object.prenom = this.data.prenom;
    object.mdp = this.data.mot_de_passe;
    object.matricule = this.data.matricule;
    object.email = this.data.email;
    object.id_droit = this.selectedDroit;
    this.isNewUser = true;
    if(this.data.id !== 0)
    {
      this.isNewUser = false;
    }
    if (this.isNewUser)
    {
      if(this.isClient)
      {
        this.droitService.InsererUtilisateurClient(object).subscribe(data => {
            // console.log(data);
            this.setVisible(false);
          },
          (error: any) => {
            alert("Une erreur est survenu lors de l'insertion du nouvel utilisateur! ");
            // console.log("Ronny ---> "+error);
          });
      }
      else
      {
        this.droitService.InsererUtilisateur(object).subscribe(data => {
            // console.log(data);
            this.setVisible(false);
          },
          (error: any) => {
            alert("Une erreur est survenu lors de l'insertion du nouvel utilisateur! ");
            // console.log("Ronny ---> "+error);
          });
      }
    }
    else
    {
      // Mettre Mdp Vide p( pas de mise a jour mdp autoriser)
      object.mdp = '';
      this.droitService.ModifierUtilisateur(object).subscribe(data => {
          // console.log(data);
          this.setVisible(false);
        },
        (error: any) => {
          alert("Une erreur est survenu lors de la mise a jour de l' utilisateur! ");
          // console.log("Ronny ---> "+error);
        });
    }

    console.log(object);
  }

  setVisible(value: boolean) {
    this.isVisible = false;
    this.changeVisibleEvent.emit(value);
  }

  /**
   * VALIDATION
   */
  createSignupForm(): FormGroup {
    return this.fb.group(
      {
        matricule: [
          null,
          Validators.compose([Validators.required])
        ],
        nom: [
          null,
          null
        ],
        prenom: [
          null,
          null
        ],
        email: [
          null,
          Validators.compose([
            // regex Validation email
            CustomValidators.patternValidator(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, {
              invalidMail: true
            }),
          ])
        ],
        droit: [
          null,
          null
        ],
        password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator
      }
    );
  }
  /**
   * Verification Etat Client
   */
  checkEtatClient() {
    console.log('Id droit' + this.selectedDroit);
    if(this.data.id === 0 && this.selectedDroit === '3')
    {
      this.isClient = true;
      console.log("IS Client");
    }else
    {
      this.isClient = false;
    }
  }

}
